var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye1 = function SvgEye1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 5a3.01 3.01 0 0 0-2.784 1.847 2.99 2.99 0 0 0 .648 3.272 3.01 3.01 0 0 0 3.279.653A3.01 3.01 0 0 0 11 8a3 3 0 0 0-.88-2.117A3.02 3.02 0 0 0 8.001 5m0 4a1.005 1.005 0 0 1-.926-.617.997.997 0 0 1 .73-1.364A1.005 1.005 0 0 1 9.004 8 1 1 0 0 1 8 9m7.93-1.372C15.835 7.4 13.615 2 8 2S.164 7.4.072 7.628a1 1 0 0 0 0 .743C.16 8.6 2.385 14 8 14s7.839-5.4 7.93-5.629a1 1 0 0 0-.003-.743zM8 12c-3.546 0-5.355-2.931-5.897-4C2.645 6.946 4.473 4 8 4c3.55 0 5.359 2.933 5.898 4-.543 1.052-2.372 4-5.898 4"
  })));
};
export default SvgEye1;